import {
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from '@mui/material';
import PinInput from 'components/Input/PinInput';
import { getAuth, RecaptchaVerifier } from 'firebase/auth';
import { app } from 'pages/DeleteUser/firebase';
import React, { useEffect, useState } from 'react';

const auth = getAuth(app);

const InputSubmitPin = ({
  phoneNumber,
  verifyCode,
  loading,
  onSendVerificationCode,
}) => {
  const [verificationCode, setVerificationCode] = useState('');
  const [timeoutSeconds, setTimeoutSeconds] = useState(0);
  const [error, setError] = useState(null);
  const [loadingResend, setLoadingResend] = useState(false);

  useEffect(() => {
    if (timeoutSeconds > 0) {
      setTimeout(() => {
        if (timeoutSeconds > 0) {
          setTimeoutSeconds(timeoutSeconds - 1);
        }
      }, 1000);
      // setTimeoutSeconds(timeoutSeconds - 1);
    }
  }, [timeoutSeconds]);

  const onClickResend = async () => {
    try {
      setLoadingResend(true);
      await onSendVerificationCode();
      setTimeoutSeconds(60);
    } catch (err) {
      console.log('err', err);
      setError(err?.message || 'Phone number is invalid');
    }
    setLoadingResend(false);
  };

  return (
    <Stack flexDirection={'column'} mt={'50px'}>
      <Box
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Typography>A 6-digit code was sent to</Typography>
        <Typography>{phoneNumber}</Typography>
      </Box>
      <Box maxWidth={'300px'} width={'100%'} mx={'auto'} mt={'10px'}>
        <PinInput length={6} onSetPinOutSide={setVerificationCode} />
      </Box>
      <Box mt={'30px'}>
        <Box
          display={'flex'}
          gap={'6px'}
          justifyContent={'center'}
          alignItems={'center'}
        >
          <Typography>Didn't Received code?</Typography>
          {timeoutSeconds <= 0 ? (
            <Button
              sx={{
                py: 0,
              }}
              onClick={onClickResend}
              id="resend"
              disabled={loadingResend}
            >
              {loadingResend ? <CircularProgress size={25} /> : 'Resend'}
            </Button>
          ) : (
            <Typography>{timeoutSeconds} seconds</Typography>
          )}
        </Box>
      </Box>
      {error && <Typography color={'red'}>{error}</Typography>}
      <Button
        sx={{
          background: 'linear-gradient(90.69deg, #5FC4AC 5.99%, #3477BD 90.2%)',
          color: 'white',
          height: '50px',
          borderRadius: '12px',
          mt: 2,
        }}
        disabled={verificationCode.length < 6 || loading}
        onClick={() => verifyCode(verificationCode)}
      >
        {loading ? <CircularProgress size={25} /> : 'Submit Pin'}
      </Button>
    </Stack>
  );
};

export default InputSubmitPin;
